module.exports = __webpack_public_path__ + "img/318200646_677570893955864_2741826105939924211_n.e0f3f728.jpg";